<template>
  <div class="about-page">
    <div class="about-wrap">
      <!-- ===== Header ===== -->
      <div class="about-header reveal">
        <div class="about-badge">{{ lg_header_about.badge }}</div>
        <h1 class="about-title">{{ lg_header_about.title }}</h1>
        <p class="about-subtitle">{{ lg_header_about.subtitle }}</p>
      </div>

      <!-- ===== Mission ===== -->
      <section class="mission">
        <div class="mission-img reveal">
          <img src="../assets/img-our-mission.jpg" alt="Team collaboration" />
        </div>
        <div class="reveal">
          <div class="mission-head">
            <v-icon size="32" color="#215295">mdi-bullseye</v-icon>
            <h2 class="mission-title">{{ lg_header_about.mission_title }}</h2>
          </div>
          <p class="text-lg mb-6">{{ lg_header_about.mission_p1 }}</p>
          <p class="text-lg">{{ lg_header_about.mission_p2 }}</p>
        </div>
      </section>

      <!-- ===== Values ===== -->
      <section class="values">
        <div class="values-head">
          <h2 class="values-title">{{ lg_header_about.values_title }}</h2>
          <p class="text-lg">{{ lg_header_about.values_subtitle }}</p>
        </div>
        <div class="values-grid">
          <div
            v-for="(v, i) in values"
            :key="v.key"
            class="value-item reveal"
            :style="{ transitionDelay: i * 150 + 'ms' }"
          >
            <div class="value-icon">
              <v-icon size="32" color="#215295">{{ v.icon }}</v-icon>
            </div>
            <h3 class="value-title">{{ lg_header_about[v.key + '_title'] }}</h3>
            <p class="value-desc">{{ lg_header_about[v.key + '_desc'] }}</p>
          </div>
        </div>
      </section>

      <!-- ===== CTA ===== -->
      <section class="cta reveal">
        <h2 class="cta-title">{{ lg_header_about.cta_title }}</h2>
        <p class="cta-subtitle">{{ lg_header_about.cta_subtitle }}</p>
        <div class="cta-actions">
          <!-- เดิมปุ่มนี้ไม่มี action: @click="onClickMenu('/register-account')" -->
          <button type="button" class="cta-btn cta-btn--white"  @click="onClickMenu('/register-account')">
            {{ lg_header_about.cta_start }}
          </button>
          <button
            type="button"
            class="cta-btn cta-btn--outline"
            @click="onClickMenu('/contact')"
          >
            {{ lg_header_about.cta_contact }}
          </button>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import api from "@/services/api";
import { server, feature } from "../services/constants";
import { lg_header_about } from "./language/lg_header_about.js";

function isInView(el) {
  const rect = el.getBoundingClientRect();
  return (
    rect.bottom > 0 &&
    rect.top <
      (window.innerHeight - 200 || document.documentElement.clientHeight - 200)
  );
}

export default {
  name: "AboutPage",
  data: () => ({
    lg_header_about: {},
    values: [
      { key: "value_security", icon: "mdi-shield-outline" },
      { key: "value_user", icon: "mdi-heart-outline" },
      { key: "value_innovation", icon: "mdi-trending-up" },
      { key: "value_community", icon: "mdi-account-multiple-outline" },
    ],
    scrollHandler: null,
    timers: [],
  }),
  created() {
    this.$store.state.page_reload = false;
    this.$store.state.loadFooter = true;
    this.lg_header_about =
      localStorage.getItem(feature.LANGUAGE) === "th"
        ? lg_header_about.lg_header_about_th
        : lg_header_about.lg_header_about_en;
  },
  mounted() {
    const userId = localStorage.getItem(server.USER_ID);
    if (userId && api.isLoggedIn()) {
      this.$router.push("/listroom");
      return;
    }

     // ให้ animation แสดงครั้งแรกครั้งเดียว
    // this.$el.querySelectorAll(".reveal").forEach((el, i) => {
    //   this.timers.push(
    //     setTimeout(() => el.classList.add("reveal--visible"), 200 + i * 150)
    //   );
    // });
    // ให้ animation เปลี่ยนทุกครั้ง เมื่อ scoll ขึ้นลง
    const targets = Array.from(this.$el.querySelectorAll(".reveal"));
        
    const inView = (el) => {
      const vh = window.innerHeight || document.documentElement.clientHeight;
      const rect = el.getBoundingClientRect();
      return rect.bottom > 0 && rect.top < vh - 100;
    };


    // const targets = this.$el.querySelectorAll(".getintouch_paragraph");
    // this.scrollHandler = () =>
    //   targets.forEach((el) =>
    //     el.classList.toggle("getintouch_paragraph--visible", isInView(el))
    //   );
    // document.addEventListener("scroll", this.scrollHandler);

        // 1) ตอนโหลดหน้า: ส่วนที่อยู่ในจอสไลด์ขึ้นทีละตัว
    let order = 0;
    targets.forEach((el) => {
      if (inView(el)) {
        this.timers.push(
          setTimeout(() => el.classList.add("reveal--visible"), 200 + order++ * 150)
        );
      }
    });

        // 2) ตอน scroll: fade in เมื่อเข้าจอ / fade out เมื่อออกจอ
    this.scrollHandler = () =>
      targets.forEach((el) => el.classList.toggle("reveal--visible", inView(el)));
    document.addEventListener("scroll", this.scrollHandler);
    this.scrollHandler();
  },
  // ใส่ทั้งสองชื่อ ใช้ได้ทั้ง Vue 2 และ Vue 3
  beforeDestroy() {
    this.cleanup();
  },
  beforeUnmount() {
    this.cleanup();
  },
  methods: {
    cleanup() {
      if (this.scrollHandler) {
        document.removeEventListener("scroll", this.scrollHandler);
        this.scrollHandler = null;
      }
      this.timers.forEach(clearTimeout);
      this.timers = [];
    },
    onClickMenu(link) {
      this.$router.push(link);
    },
  },
};
</script>

<style scoped>
.about-page {
  min-height: 100vh;
  padding: 80px 0;
  background: #ffffff;
  color: #0a0a0a;
}
.about-wrap {
  max-width: 1280px;
  margin: 0 auto;
  padding: 0 16px;
}
@media (min-width: 640px) {
  .about-wrap { padding: 0 24px; }
}
@media (min-width: 1024px) {
  .about-wrap { padding: 0 32px; }
}

.text-lg {
  font-size: 1.25rem;
  line-height: 1.75rem;
  color: #4b5563;
  margin: 0;
}
.mb-6 { margin-bottom: 24px !important; }

/* Header */
.about-header {
  text-align: center;
  margin-bottom: 80px;
}
.about-badge {
  display: inline-block;
  padding: 8px 16px;
  border-radius: 9999px;
  font-size: 0.875rem;
  line-height: 1.25rem;
  margin-bottom: 24px;
  background-color: rgba(33, 82, 149, 0.1);
  color: #215295;
}
.about-title {
  font-size: 3rem;
  line-height: 1;
  font-weight: 500;
  margin: 0 0 24px;
}
.about-subtitle {
  font-size: 1.25rem;
  line-height: 1.75rem;
  color: #4b5563;
  max-width: 48rem;
  margin: 0 auto;
}

/* Mission */
.mission {
  display: grid;
  grid-template-columns: 1fr;
  gap: 48px;
  align-items: center;
  margin-bottom: 144px; /* mb-16 + section mb-20 */
}
@media (min-width: 1024px) {
  .mission { grid-template-columns: 1fr 1fr; }
}
.mission-img {
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1),
    0 8px 10px -6px rgba(0, 0, 0, 0.1);
}
.mission-img img {
  width: 100%;
  height: auto;
  display: block;
}
.mission-head {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
}
.mission-title {
  font-size: 1.875rem;
  line-height: 2.25rem;
  font-weight: 500;
  margin: 0;
}

/* Values */
.values {
  padding: 64px 0;
  margin-bottom: 80px;
}
.values-head {
  text-align: center;
  margin-bottom: 64px;
}
.values-title {
  font-size: 2.25rem;
  line-height: 2.5rem;
  font-weight: 500;
  margin: 0 0 16px;
}
.values-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 32px;
}
@media (min-width: 768px) {
  .values-grid { grid-template-columns: repeat(2, 1fr); }
}
@media (min-width: 1024px) {
  .values-grid { grid-template-columns: repeat(4, 1fr); }
}
.value-item {
  text-align: center;
  padding: 24px;
}
.value-icon {
  width: 64px;
  height: 64px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 16px;
  background-color: rgba(33, 82, 149, 0.1);
}
.value-title {
  font-size: 1.25rem;
  line-height: 1.75rem;
  font-weight: 500;
  margin: 0 0 12px;
}
.value-desc {
  color: #4b5563;
  margin: 0;
}

/* CTA */
.cta {
  text-align: center;
  padding: 64px 32px;
  border-radius: 16px;
  background-color: #215295;
}
.cta-title {
  font-size: 1.875rem;
  line-height: 2.25rem;
  font-weight: 500;
  color: #ffffff;
  margin: 0 0 16px;
}
.cta-subtitle {
  font-size: 1.25rem;
  line-height: 1.75rem;
  color: rgba(255, 255, 255, 0.9);
  margin: 0 0 32px;
}
.cta-actions {
  display: flex;
  flex-direction: column;
  gap: 16px;
  justify-content: center;
  align-items: center;
}
@media (min-width: 640px) {
  .cta-actions { flex-direction: row; }
}
.cta-btn {
  display: inline-block;
  padding: 16px 32px;
  border-radius: 8px;
  font-size: 1rem;
  cursor: pointer;
  transition: all 0.15s ease;
}
.cta-btn--white {
  background: #ffffff;
  color: #215295;
  border: 2px solid #ffffff;
}
.cta-btn--white:hover {
  background: #f3f4f6;
  border-color: #f3f4f6;
}
.cta-btn--outline {
  background: transparent;
  color: #ffffff;
  border: 2px solid #ffffff;
}
.cta-btn--outline:hover {
  background: rgba(255, 255, 255, 0.1);
}

@media (max-width: 599px) {
  .about-title { font-size: 2.25rem; }
}

/* Animations */
.reveal {
  opacity: 0;
  transform: translateY(40px);
  transition: opacity 0.8s ease, transform 0.8s ease;
}
.reveal--visible {
  opacity: 1;
  transform: translateY(0);
}
.getintouch_paragraph {
  opacity: 0;
  transform: translateY(60px);
  transition: opacity 0.8s ease, transform 0.8s ease;
}
.getintouch_paragraph--visible {
  opacity: 1;
  transform: translateY(0);
}
</style>